import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";

import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import * as Yup from "yup";
import { DisplayAddFolderForm } from "./DisplayAddFolderForm";






type AddFolderFormValueType = {

  folder_name: string;

};

type AddFolderFormProps = {

  referenceDrawer: DrawerType
  onCloseDrawer: (closeDrawer: boolean) => void;
  callBackFn: (name: string) => void
};

export const AddFolderForm: React.FC<AddFolderFormProps> = ({
  callBackFn,
  referenceDrawer,
  onCloseDrawer
}) => {


  const onSubmit = async (
    values: AddFolderFormValueType,
    formikHelpers: FormikHelpers<AddFolderFormValueType>
  ) => {

    await onAddFolder(values, formikHelpers, { isManuallyResettingForm: true });
  };

  const initialValues: AddFolderFormValueType = {
    folder_name: "",

  };

  const AddFolderFormSchema = Yup.object().shape({
    folder_name: Yup.string().matches(/^(?=.*[a-z0-9])[a-z0-9.+]{3,63}$/, 'Folder name is not in correct format').required("Folder name is required"),
    // password: Yup.string().required("global.error.required.default"),
  });

  const handleAddFolder = async (
    values: AddFolderFormValueType,
    formikHelpers: FormikHelpers<AddFolderFormValueType>,
    options: {

    }
  ) => {

    callBackFn(values.folder_name)
    onCloseDrawer(false);


  };

  const formSubmitToAddFolder = () => {

    return [
      async (
        values: AddFolderFormValueType,
        formikHelpers: FormikHelpers<AddFolderFormValueType>
      ) => {

        return handleAddFolder(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "downloads.basic.detail.Generate",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: [
          "downloads.basic.detail",
          "add",
        ].join("."),
        onError: () => {
          // refetch entity from server
          // queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onAddFolder = useFormSubmit(...formSubmitToAddFolder());




  return (


    <>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={AddFolderFormSchema}


      >

        <DirtyFormPrompt>
          <DisplayAddFolderForm
            referenceDrawer={referenceDrawer}

          // onCloseDrawer={onCloseDrawer}
          />

        </DirtyFormPrompt>

      </Formik>

    </>

  );
};
